import { useMutation } from '@tanstack/react-query'
import { checkInCount } from '../index'

const useCheckInCount = () =>
  useMutation({
    mutationFn: checkInCount,
  })

export default useCheckInCount
